import { ADMIN_LOGIN, ADMIN_LOGOUT } from '../types/type';

const initState = {
    adminToken: '',
    isAdmin: false
}

const AdminReducer = (state = initState, action) => {
    switch (action.type) {
        case ADMIN_LOGIN:
            return {
                ...state,
                adminToken: action.payload,
                isAdmin: true
            }

        case ADMIN_LOGOUT:
            return {
                ...state,
                adminToken: '',
                isAdmin: false
            }

        default:
            return state;
    }
}

export default AdminReducer;